var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout"},[_c('navbar'),_vm._v(" "),_c('header',{staticClass:"header-background"},[_c('header-banner'),_vm._v(" "),_c('header-title')],1),_vm._v(" "),_c('div',{staticClass:"container mt-4"},[_c('child')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/assets/js/layouts/default.vue?vue&type=template&id=d71b90b4&scoped=true&
// module id = null
// module chunks = 